import { schema } from "normalizr";

const radformelSchema = new schema.Entity(
  "radformel",
  {},
  { idAttribute: "id" }
);

export { radformelSchema };
